export default "__VITE_ASSET__BaQVpgC___"